import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DepenserecetteProfileLayout from './DepenserecetteProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import EleveService from '../../services/EleveService';
import DepenserecetteService from '../../services/DepenserecetteService';
import PersonnelService from '../../services/PersonnelService';

const ViewDepenserecette = ({ onClick }) => {
	const { id } = useParams();
	const [depenserecette, setDepenserecette] = useState(null); // Changed this from "eleve" to "Depenserecette"
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [selectedPersonnel, setSelectedPersonnel] = useState('');
	const [selectedType, setSelectedType] = useState('');
	const [personnelOptions, setPersonnelOptions] = useState([]);

	useEffect(() => {
		Promise.all([DepenserecetteService.getDepenserecette(id)]).then(
			([depenserecetteData]) => {
				// Added "eleveData" to unpack second promise result
				setDepenserecette(depenserecetteData.data);

				if (depenserecetteData && depenserecetteData.data) {
					const typeDepense = depenserecetteData.data.type;
					setSelectedType(typeDepense);

					const personnelDepense = depenserecetteData.data.personnel;
					setSelectedPersonnel(personnelDepense);
				}
			}
		);
	}, [id]);

	const TYPE_CHOICES = [
		{ value: 'depense', label: 'Depense' },
		{ value: 'recette', label: 'Recette' }
	];

	useEffect(() => {
		const fetchPersonnelOptions = async () => {
			try {
				const Personnels = await PersonnelService.getPersonnelOptions();
				setPersonnelOptions(Personnels);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchPersonnelOptions();
	}, []);

	const PERSONNEL_CHOICES = personnelOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const depenserecetteData = new FormData();

				// Add all your form data to the FormData
				depenserecetteData.append('categorie', form.categorie.value);
				depenserecetteData.append('description', form.description.value);
				depenserecetteData.append('fournisseur', form.fournisseur.value);
				depenserecetteData.append('date', form.date.value);
				depenserecetteData.append('montant', form.montant.value);
				depenserecetteData.append('reference', form.reference.value);
				depenserecetteData.append('type', form.type.value);
				depenserecetteData.append('personnel', form.personnel.value);

				// Call the EleveService to create the eleve
				const response = await DepenserecetteService.updateDepenserecette(
					id,
					depenserecetteData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations du bilan',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<DepenserecetteProfileLayout>
			{depenserecette && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									{/* type */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="type">
												Type de Dépense <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="type"
												required
												value={selectedType}
												isInvalid={!!feedbackMessages['type']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedType(value);
													// Reset feedback messages for points fields when type changes
													setFeedbackMessages({});
												}}
											>
												<option value="">
													Sélectionner le type de dépense
												</option>
												{TYPE_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['type']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* montant  */}
										<Form.Group>
											<Form.Label htmlFor="montant">
												Montant <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="montant"
												type="number"
												placeholder="Saisir le montant "
												id="montant"
												required
												isInvalid={!!feedbackMessages['montant']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														montant: e.target.value
															? ''
															: 'Le montant est requis.'
													}));
												}}
												defaultValue={depenserecette.montant}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['montant']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* date */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="date">
												Date d'achat <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="date"
												type="text"
												placeholder="Saisir la date du Bilan"
												id="date"
												required
												isInvalid={!!feedbackMessages['date']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														date: e.target.value ? '' : 'La date est requise.'
													}));
												}}
												defaultValue={depenserecette.date}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* categorie */}
										<Form.Group>
											<Form.Label htmlFor="categorie">
												Nom <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="categorie"
												type="text"
												placeholder="Saisir la categorie du Bilan"
												id="categorie"
												required
												isInvalid={!!feedbackMessages['categorie']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														categorie: e.target.value
															? ''
															: 'La categorie est requis.'
													}));
												}}
												defaultValue={depenserecette.categorie}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['categorie']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/*  description  */}
									<Col xs={12} className="mb-3">
										<Form.Group>
											<Form.Label htmlFor="description">
												Description <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="description"
												as="textarea"
												placeholder="Saisir la description "
												id="description"
												required
												isInvalid={!!feedbackMessages['description']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														description: e.target.value
															? ''
															: 'Le description est requis.'
													}));
												}}
												defaultValue={depenserecette.description}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['description']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/*  reference  */}
										<Form.Group>
											<Form.Label htmlFor="reference">Reference</Form.Label>
											<Form.Control
												name="reference"
												type="text"
												placeholder="categorie@example.com"
												id="reference"
												isInvalid={!!feedbackMessages['reference']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														reference: e.target.value
															? ''
															: "La dreference n'est pas valide."
													}));
												}}
												defaultValue={depenserecette.reference}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['reference']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* fournisseur */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="fournisseur">
												Fournisseur <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="fournisseur"
												type="text"
												placeholder="Saisir le fournisseur "
												id="fournisseur"
												isInvalid={!!feedbackMessages['fournisseur']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														type: e.target.value ? '' : ''
													}));
												}}
												defaultValue={depenserecette.fournisseur}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['fournisseur']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* personnel */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="personnel">
												Personnel <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="personnel"
												required
												value={selectedPersonnel}
												isInvalid={!!feedbackMessages['personnel']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedPersonnel(value);
													// Reset feedback messages for points fields when personnel changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le personnel</option>
												{PERSONNEL_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback personnel="invalid">
												{feedbackMessages['personnel']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</DepenserecetteProfileLayout>
	);
};

export default ViewDepenserecette;
